import { render } from "./PpmDiscrepancyDetailDialog.vue?vue&type=template&id=0b276b78&scoped=true"
import script from "./PpmDiscrepancyDetailDialog.vue?vue&type=script&lang=js"
export * from "./PpmDiscrepancyDetailDialog.vue?vue&type=script&lang=js"

import "./PpmDiscrepancyDetailDialog.vue?vue&type=style&index=0&id=0b276b78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b276b78"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBar,QIcon,QSpace,QBtn,QTooltip,QCardSection,QMarkupTable,QSpinnerDots});qInstall(script, 'directives', {ClosePopup});
